import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/plans/_plans-client.tsx");
